import { service } from '@maia/quotation';
import { QueryOptions, queryOptions } from '@tanstack/react-query';

export type Quotations = Awaited<ReturnType<(typeof service)['getQuotations']>>;

export function getQuotationsOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Quotations>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['quotations', [search]],
    queryFn: async () => await service.getQuotations(search),
    initialData,
  });
}
